export const Routes = {
  Message: {
    SendText: "message/sendText",
    SendMedia: "message/sendMedia",
    SendVoice: "message/sendWhatsAppAudio",
    SendSticker: "message/sendSticker",
    SendLocation: "message/sendLocation",
    SendContact: "message/sendContact",
    SendPoll: "message/sendPoll",
    SendReaction: "message/sendReaction",
    SendTemplate: "message/sendTemplate",
    SendStatus: "message/sendStatus",
    SendList: "message/sendList",
  },
  Chats: {
    Check: "chat/whatsappNumbers",
    FindAll: "chat/findChats",
    SendPresence: "chat/sendPresence",
    MarkAsRead: "chat/markMessageAsRead",
    MarkAsUnread: "chat/markChatUnread",
    Archive: "chat/archive",
    DeleteMessage: "chat/deleteMessageForEveryone",
    FetchProfilePicture: "chat/fetchProfilePictureUrl",
    FindContacts: "chat/findContacts",
    FindMessages: "chat/findMessages",
    FindStatusMessage: "chat/findStatusMessage",
    UpdateMessage: "chat/updateMessage",
  },
  Groups: {
    FindAll: "group/fetchAllGroups",
    FindByJid: "group/findGroupInfos",
    FindByInviteCode: "group/inviteInfo",
    Create: "group/create",
    UpdatePicture: "group/updateGroupPicture",
    UpdateSubject: "group/updateGroupSubject",
    UpdateDescription: "group/updateGroupDescription",
    FetchInviteCode: "group/fetchInviteCode",
    AcceptInviteCode: "group/acceptInviteCode",
    RevokeInviteCode: "group/revokeInviteCode",
    SendGroupInvite: "group/sendGroupInvite",
    FindMembers: "group/findGroupMembers",
    UpdateMembers: "group/updateGroupMembers",
    UpdateSetting: "group/updateGroupSetting",
    ToggleEphemeral: "group/toggleEphemeral",
    Leave: "group/leaveGroup",
  },
  Profile: {
    FetchBusinessProfile: "chat/fetchBusinessProfile",
    FetchProfile: "chat/fetchProfile",
    UpdateName: "chat/updateProfileName",
    UpdateStatus: "chat/updateProfileStatus",
    UpdatePicture: "chat/updateProfilePicture",
    RemovePicture: "chat/removeProfilePicture",
    FetchPrivacySettings: "chat/fetchPrivacySettings",
    UpdatePrivacySettings: "chat/updatePrivacySettings",
  },
  Webhook: {
    Set: "webhook/set",
    Find: "webhook/find",
  },
  Settings: {
    Set: "settings/set",
    Find: "settings/find",
  },
  Instance: {
    Create: "instance/create",
    FetchAll: "instance/fetchInstances",
    Connect: "instance/connect",
    Restart: "instance/restart",
    ConnectionState: "instance/connectionState",
    Logout: "instance/logout",
    Delete: "instance/delete",
    SetPresence: "instance/setPresence",
  },
};
